var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b20088d6\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DocumenntPendingIcon.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/icons/DocumenntPendingIcon.vue
// module id = 1439
// module chunks = 159